import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "./motion";

export default function EmotionalMoment() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      ref={ref}
      data-testid="emotional-moment"
      className="relative overflow-hidden h-[95vh] min-h-[600px] flex items-center justify-center"
    >
      <motion.img
        src="https://images.pexels.com/photos/5779787/pexels-photo-5779787.jpeg"
        alt="A chef working the flame on a busy kitchen pass"
        style={{ y }}
        className="absolute inset-0 w-full h-[116%] object-cover -top-[8%]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[#14103a]/80" />

      <div className="relative px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 1, ease: EASE }}
          className="font-display font-light text-4xl sm:text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[1.12] text-paper max-w-4xl mx-auto text-balance"
        >
          Great restaurants run on instinct.
          <br />
          Better ones have Verlo.
        </motion.h2>
      </div>
    </section>
  );
}
